<ng-template #contentTpl let-offcanvas>
  <div class="offcanvas-resizer"></div>

  <div class="offcanvas-header offcanvas-top-header">
    <h4 class="offcanvas-title">{{ title }}</h4>
    <div class="ms-auto d-flex align-items-center gap-2">
      <ng-container *ngIf="header">
        <ng-container *ngTemplateOutlet="header"></ng-container>
      </ng-container>
      <button type="button" class="btn-close" aria-label="Close" (click)="offcanvas.dismiss()"></button>
    </div>
  </div>

  <div class="offcanvas-body" #offcanvasBody>
    <ng-container *ngTemplateOutlet="body"></ng-container>
  </div>

  <div class="offcanvas-footer" *ngIf="!hideFooter">
    <ng-container *ngIf="footer">
      <ng-container *ngTemplateOutlet="footer"> </ng-container>
    </ng-container>
    <div *ngIf="!footer" class="d-flex w-100 justify-content-between align-items-center gap-2">
      <div>
        <button class="btn btn-progreso" (click)="onSubmit(true)" [disabled]="formInvalid || saving">
          <span *ngIf="saveLabel && saveLabel.length > 0">{{ saveLabel }}</span>
          <span *ngIf="!saveLabel">{{ 'save_and_close' | label : 'general' | async }}</span>
        </button>

        <button class="btn btn-cancel" (click)="onCancel()">
          {{ 'cancel' | label : 'general' | async }}
        </button>
      </div>
      <div *ngIf="centerFooter" class="flex-grow-1 d-flex justify-content-center">
        <ng-container *ngTemplateOutlet="centerFooter"> </ng-container>
      </div>
      <div *ngIf="!hideSaveButton">
        <button *ngIf="saving" type="button" class="btn btn-outline">
          <i class="fas fa-sync-alt fa-spin"></i>
          {{ 'saving' | label : 'general' | async }}
        </button>
        <button *ngIf="!saving && !pendingChanges" type="button" class="btn btn-green" (click)="onSubmit(false)" [disabled]="formInvalid || saving">
          <i class="fas fa-check"></i>
          {{ 'savedsuccessfully' | label : 'general' | async }}
        </button>
        <button *ngIf="!saving && pendingChanges" type="button" (click)="onSubmit(false)" class="btn btn-outline-danger" [disabled]="formInvalid || saving">
          <i class="fas fa-exclamation-triangle text-danger"></i>
          {{ 'unsaved_changes' | label : 'general' | async }}
        </button>
      </div>
    </div>
  </div>
</ng-template>
